
// Graph Colours
export const DASHBOARD_GRAPH_MAIN_COLOUR = '#408CCB'; // component colour
export const DASHBOARD_GRAPH_MAIN_FADED_COLOUR = '#408CCB';

export const DASHBOARD_GRAPH_BAR_COLOUR_GREY = '#B1B3C0';
export const DASHBOARD_GRAPH_BAR_FADED_COLOUR_GREY = '#B1B3C0';
export const DASHBOARD_GRAPH_BAR_COLOUR_GREEN = '#60C08D';
export const DASHBOARD_GRAPH_BAR_FADED_COLOUR_GREEN = '#60C08D';
export const DASHBOARD_GRAPH_BAR_COLOUR_RED = '#E2523D';
export const DASHBOARD_GRAPH_BAR_FADED_COLOUR_RED = '#E2523D';

export const DASHBOARD_GRAPH_PIE_BORDER_COLOUR = 'rgb(207,212,214)';
export const DASHBOARD_GRAPH_HOVER_BORDER_COLOUR = 'rgba(220,220,220,1)';

export const DASHBOARD_DOUGHNUT_COLOUR1 = DASHBOARD_GRAPH_MAIN_COLOUR; // from above
export const DASHBOARD_DOUGHNUT_COLOUR2 = 'rgb(68,135,96)';
export const DASHBOARD_DOUGHNUT_COLOUR3 = 'rgb(44,139,145)';
export const DASHBOARD_DOUGHNUT_COLOUR4 = 'rgb(103,106,108)';
export const DASHBOARD_DOUGHNUT_COLOUR5 = 'rgba(96,192,141)';
export const DASHBOARD_DOUGHNUT_COLOUR6 = 'rgb(211,142,83)';
export const DASHBOARD_DOUGHNUT_COLOUR7 = 'rgb(186,192,105)';
export const DASHBOARD_DOUGHNUT_COLOUR8 = 'rgb(192,91,74)';
export const DASHBOARD_DOUGHNUT_COLOUR9 = 'rgb(53,186,192)';
export const DASHBOARD_DOUGHNUT_COLOUR10 = 'rgb(117,115,192)';
export const DASHBOARD_DOUGHNUT_COLOUR11 = 'rgb(192,111,158)';
export const DASHBOARD_DOUGHNUT_COLOUR12 = 'rgb(48,101,192)';
export const DASHBOARD_DOUGHNUT_COLOUR13 = 'rgb(192,167,108)';
export const DASHBOARD_DOUGHNUT_COLOUR14 = 'rgb(177,179,192)';
export const DASHBOARD_DOUGHNUT_COLOUR15 = 'rgb(218,68,52)';

export const doughnutColourArray = [
  DASHBOARD_DOUGHNUT_COLOUR1,
  DASHBOARD_DOUGHNUT_COLOUR2,
  DASHBOARD_DOUGHNUT_COLOUR3,
  DASHBOARD_DOUGHNUT_COLOUR4,
  DASHBOARD_DOUGHNUT_COLOUR5,
  DASHBOARD_DOUGHNUT_COLOUR6,
  DASHBOARD_DOUGHNUT_COLOUR7,
  DASHBOARD_DOUGHNUT_COLOUR8,
  DASHBOARD_DOUGHNUT_COLOUR9,
  DASHBOARD_DOUGHNUT_COLOUR10,
  DASHBOARD_DOUGHNUT_COLOUR11,
  DASHBOARD_DOUGHNUT_COLOUR12,
  DASHBOARD_DOUGHNUT_COLOUR13,
  DASHBOARD_DOUGHNUT_COLOUR14,
  DASHBOARD_DOUGHNUT_COLOUR15,
];

// Tag Colours
export const INSPECTION_LIST_TAG_COLOUR_COMPLIANCE = 'rgb(100,135,100)';
export const INSPECTION_LIST_TAG_COLOUR_OTHERS = 'rgb(103,106,108)';
export const INSPECTION_LIST_TAG_COLOUR_ALL = '#408CCB'; // component colour
export const INSPECTION_LIST_TAG_COLOUR_MY = 'rgb(69,136,145)';
export const INSPECTION_LIST_TAG_COLOUR_CHECK = '#cc6925';
export const INSPECTION_LIST_TAG_COLOUR_NEW_DAMAGE = '#9d2928';
export const INSPECTION_LIST_TAG_COLOUR_OLD_DAMAGE = 'rgb(211,185,83)';
export const INSPECTION_LIST_TAG_COLOUR_COSTS = 'rgb(117,115,192)';
export const INSPECTION_LIST_TAG_COLOUR_DEFECTS = 'rgb(139,85,52)';
export const INSPECTION_LIST_TAG_COLOUR_NO_DEFECTS = 'rgb(74,162,81)';
